<div class="show-week-calendar-header">
  <button mat-icon-button class="show-week-double-arrow" [disabled]="disabled" (click)="previousClicked('year')">
    <mat-icon>keyboard_arrow_left</mat-icon>
    <mat-icon>keyboard_arrow_left</mat-icon>
  </button>
  <button mat-icon-button [disabled]="disabled" (click)="previousClicked('month')">
    <mat-icon>keyboard_arrow_left</mat-icon>
  </button>
  <span (click)="clickLabel()" class="show-week-calendar-header-label">
    {{ periodLabel }}
  </span>
  <button mat-icon-button [disabled]="disabled" (click)="nextClicked('month')">
    <mat-icon>keyboard_arrow_right</mat-icon>
  </button>
  <button mat-icon-button class="show-week-double-arrow" [disabled]="disabled" (click)="nextClicked('year')">
    <mat-icon>keyboard_arrow_right</mat-icon>
    <mat-icon>keyboard_arrow_right</mat-icon>
  </button>
</div>
